import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.invite');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-invite',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.widget.fund.invite/view.scss */
:host {
  display: block;
  height: 100%;
}

table td,
table th {
  vertical-align: baseline;
}

.form-control {
  border-radius: 4px;
}

.btn-opt {
  margin: 4px;
  border-radius: 30px;
  height: auto;
  font: normal normal normal 16px Montserrat;
  padding: 12px 30px;
  border: 1px solid #72787F;
}
.btn-opt:hover {
  color: #FF5933;
  border: 1px solid #FF5933;
  background-color: #FFF2ED;
}
.btn-opt.active {
  background-color: #FF5933;
  color: #FFF;
  border: 1px solid #FF5933;
}`],
})
export class PortalLpsysadminWidgetFundInviteComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;
    @Input() mode: any = "invite";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership(["admin", "super_admin"], "/");
        await this.loadFields();
        await this.loadKeywords();
        await this.load();
        await this.service.loading.hide();
    }

    public listloaded: boolean = false;
    public list: any = [];
    public status: string = 'active';
    public user_status: string = '승인';
    public total: number = 0;
    public count: number = 0;
    public allcheck: boolean = false;

    public show_send_message: any = null;
    public checked_user_id: any = [];
    public show_send_email: any = null;
    public checked_email_list: any = [];
    public emailTargetScope: string = "selected";
    public emailSendMode: string = "all";
    public emailSkippedSelectedCount: number = 0;
    public emailSending: boolean = false;
    public emailForm: any = {
        title: "",
        content: "",
        attachments: [],
    };

    public fieldList: string[] = [];
    public subFieldList: string[] = [];

    public keywords: string[] = [];
    public newKeyword: string = '';
    public keywordsDirty: boolean = false;

    public search: any = {
        page: 1,
        orderby: "name",
        direction: "ASC",
        text: "",
        field: "",
        sub_field: "",
    };

    public async loadFields() {
        let { code, data } = await wiz.call("fields");
        if (code == 200) {
            this.fieldList = data.fields || [];
            this.subFieldList = data.sub_fields || [];
        }
    }

    public async loadKeywords() {
        let { code, data } = await wiz.call("load_keywords", { fund_id: this.fund.id });
        if (code == 200) {
            this.keywords = data.keywords || [];
            this.keywordsDirty = false;
        }
        await this.service.render();
    }

    public async addKeyword() {
        let kw = this.newKeyword.trim();
        if (!kw) return;
        if (this.keywords.includes(kw)) {
            this.newKeyword = '';
            await this.service.render();
            return;
        }
        this.keywords.push(kw);
        this.newKeyword = '';
        this.keywordsDirty = true;
        await this.service.render();
    }

    public async removeKeyword(index: number) {
        this.keywords.splice(index, 1);
        this.keywordsDirty = false;
        await this.service.render();
        await this._saveKeywords();
    }

    private async _saveKeywords() {
        try {
            let { code } = await wiz.call("save_keywords", { fund_id: this.fund.id, keywords: JSON.stringify(this.keywords) });
            if (code != 200) {
                await this.alert("키워드 저장에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("키워드 저장 중 오류가 발생했습니다.");
        }
    }

    public async saveKeywords() {
        await this.service.loading.show();
        let resultCode = 0;
        let errorOccurred = false;
        try {
            let { code } = await wiz.call("save_keywords", { fund_id: this.fund.id, keywords: JSON.stringify(this.keywords) });
            resultCode = code;
            if (code == 200) {
                this.keywordsDirty = false;
            }
        } catch (e) {
            errorOccurred = true;
        }
        await this.service.loading.hide();
        await this.service.render();
        if (errorOccurred) {
            await this.alert("키워드 저장 중 오류가 발생했습니다.");
        } else if (resultCode == 200) {
            await this.alert("키워드가 저장되었습니다.", "success");
        } else {
            await this.alert("키워드 저장에 실패했습니다.");
        }
    }

    public async autoInviteBulk() {
        if (this.keywords.length === 0) {
            return await this.alert("등록된 키워드가 없습니다.");
        }
        if (this.keywordsDirty) {
            return await this.alert("키워드를 먼저 저장해주세요.");
        }
        await this.service.loading.show();
        try {
            let { code, data } = await wiz.call("auto_invite_preview", { fund_id: this.fund.id });
            if (code != 200) return await this.alert("미리보기 조회 중 오류가 발생했습니다.");

            let previewCount = data.count;
            if (previewCount === 0) {
                return await this.alert("추천인 키워드에 매칭되는 미초대 회원이 없습니다.", "success");
            }

            let res = await this.service.alert.show({
                title: '추천인 기준 일괄 초대',
                message: `키워드에 매칭되는 미초대 회원 ${previewCount}명을 일괄 초대하시겠습니까?`,
                cancel: '취소',
                actionBtn: 'success',
                action: '일괄 초대',
                status: 'success'
            });
            if (!res) return;

            let result = await wiz.call("auto_invite_bulk", { fund_id: this.fund.id });
            if (result.code == 200) {
                await this.alert(`${result.data.count}명이 초대되었습니다.`, "success");
                await this.load(this.search.page);
            } else {
                await this.alert("일괄 초대 중 오류가 발생했습니다.");
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async filterByField(value: string) {
        this.search.field = this.search.field === value ? '' : value;
        await this.load();
    }

    public async filterBySubField(value: string) {
        this.search.sub_field = this.search.sub_field === value ? '' : value;
        await this.load();
    }

    public pagination: any = {
        end: -1,
        start: -1,
    };

    public async alert(message: string, status: any = "error") {
        return await this.service.alert.show({
            title: '',
            message: message,
            cancel: false,
            actionBtn: status,
            action: "확인",
            status: status
        });
    }

    public async load(page: number = 1, status: any = null) {
        if (!status) status = this.status;
        this.listloaded = false;
        let { code, data } = await wiz.call("list", {
            id: this.fund.id,
            page: page,
            text: this.search.text,
            field: this.search.field,
            sub_field: this.search.sub_field,
            orderby: this.search.orderby,
            direction: this.search.direction,
            user_status: this.user_status,
            status: status
        });
        if (code != 200) return;
        let { rows, lastpage, total, count } = data;
        const startpage = Math.floor((page - 1) / 10) * 10 + 1;
        this.search.page = page;
        this.list = rows.map(item => {
            return {
                ...item,
                selected: false
            };
        });
        this.pagination.start = startpage;
        this.pagination.end = lastpage;
        this.listloaded = true;
        this.status = status;
        this.total = total;
        this.count = count;
        await this.service.render();
    }

    public async pageMove(page: number) {
        await this.load(page);
    }

    public async changeRole(item: any) {
        if (item.check) {
            if (item.check.status == '참여') return await this.alert("참여중인 조합원은 열람권한을 변경할 수 없습니다.");
            if (item.check.status == '대기') return await this.alert("대기중인 조합원은 열람권한을 변경할 수 없습니다.");
        }

        if (this.mode == 'invite') {
            item.check = !item.check;
        } else {
            item.check = true;
        }

        let user = {
            email: item.email,
            fund_id: this.fund.id,
            check: item.check,
            invite: this.mode == 'invite'
        };
        const { code } = await wiz.call("update", user);
        if (code != 200) return alert("error");
        await this.load(this.search.page);
    }

    public activeClass(target: string, status: string) {
        if (target == status) {
            return "group flex gap-x-3 mr-2 rounded-full bg-zinc-600 px-3.5 py-2 text-sm font-semibold text-white hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ";
        }
        return "group flex gap-x-3 rounded-md mr-2 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-zinc-600";
    }

    public target_user: any = null;

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            this.show_send_message = null;
            this.checked_user_id = [];
            this.show_send_email = null;
            this.checked_email_list = [];
            await this.service.render();
        }
    }

    public allCheck(e) {
        document.querySelectorAll("input[type='checkbox']").forEach(item => {
            if (item.classList.contains("ng-valid") && item.checked !== e.target.checked) {
                item.click();
            }
        });
    }

    public async changeSelectedRole(e: any) {
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].selected) {

                if (this.mode == 'invite') {
                    this.list[i].check = !this.list[i].check;
                } else {
                    this.list[i].check = true;
                }

                let user = {
                    email: this.list[i].email,
                    fund_id: this.fund.id,
                    check: this.list[i].check,
                    invite: this.mode == 'invite'
                };

                const { code } = await wiz.call("update", user);
                if (code != 200) return alert("error");
            }
        }

        await this.load(this.search.page);
    }

    public async onClickOrder(order: string = "name") {
        if (this.search.orderby === order) {
            this.search.direction = this.search.direction === "ASC" ? "DESC" : "ASC";
        } else {
            this.search.orderby = order;
            this.search.direction = "ASC";
        }

        console.log(this.search)

        await this.service.render(500);
        await this.load();
    }

    public async revokeAll() {
        let res = await this.service.alert.show({
            title: '',
            message: '참여중인 조합원을 제외한 모든 열람권한을 해제하시겠습니까?',
            cancel: '취소',
            actionBtn: 'error',
            action: '전체 해제',
            status: 'error'
        });
        if (!res) return;

        await this.service.loading.show();
        for (let i = 0; i < this.list.length; i++) {
            const item = this.list[i];
            if (!item.check) continue;
            if (item.check.status === '참여') continue;

            let user = {
                email: item.email,
                fund_id: this.fund.id,
                check: false,
                invite: this.mode == 'invite'
            };
            await wiz.call("update", user);
        }
        await this.service.loading.hide();
        await this.load(this.search.page);
    }

    public selectedRows() {
        return this.list.filter(item => item.selected);
    }

    public selectedEmailRows(skipSent: boolean = false) {
        let seen: any = {};
        return this.selectedRows().filter(item => {
            if (!item.email) return false;
            if (skipSent && item.invite_email_sent_at) return false;
            let key = (item.email || '').toLowerCase();
            if (seen[key]) return false;
            seen[key] = true;
            return true;
        });
    }

    public defaultEmailTitle() {
        let fundName = this.fund?.name || this.fund?.title || "조합";
        return `[${fundName}] 조합 결성 안내`;
    }

    public fundStatusPath() {
        let status = this.fund?.investment_status;
        if (status === "결성") return "formed";
        if (["정산", "해산", "청산"].includes(status)) return "exit";
        return "operating";
    }

    public automaticEmailLink() {
        if (!this.fund?.id) return "";
        return `${location.origin}/fund/${this.fundStatusPath()}/${this.fund.id}/info`;
    }

    public emailTargetDescription() {
        if (this.emailTargetScope === "all") {
            if (this.emailSendMode === "unsent") {
                return "승인된 전체 대상 중 아직 이메일을 받지 않은 사람에게 발송합니다.";
            }
            return "승인된 전체 대상에게 다시 발송합니다.";
        }

        let count = this.checked_email_list.length;
        if (this.emailSendMode === "unsent") {
            return `선택한 대상 중 미발송자 ${count}명에게 발송합니다.`;
        }
        return `선택한 대상 ${count}명에게 발송합니다.`;
    }

    public refreshEmailTargets() {
        if (this.emailTargetScope !== "selected") {
            this.checked_email_list = [];
            this.emailSkippedSelectedCount = 0;
            return;
        }

        let selected = this.selectedRows();
        let targets = this.selectedEmailRows(this.emailSendMode === "unsent");
        this.checked_email_list = targets.map(item => item.email);
        this.emailSkippedSelectedCount = this.emailSendMode === "unsent"
            ? selected.filter(item => item.email && item.invite_email_sent_at).length
            : 0;
    }

    public async setEmailTargetScope(scope: string) {
        if (scope === "selected" && this.selectedRows().length === 0) {
            return await this.alert("이메일을 보낼 사람을 먼저 선택해주세요.");
        }

        this.emailTargetScope = scope;
        this.refreshEmailTargets();
        await this.service.render();
    }

    public async onEmailSendModeChange() {
        this.refreshEmailTargets();
        await this.service.render();
    }

    public async openSendEmail() {
        if (this.user_status !== "승인") {
            return await this.alert("승인 목록에서 선택한 사람에게만 이메일을 보낼 수 있습니다.");
        }

        this.emailTargetScope = this.selectedRows().length > 0 ? "selected" : "all";
        this.emailSendMode = "unsent";
        this.emailForm = {
            title: this.defaultEmailTitle(),
            content: "",
            attachments: [],
        };
        this.refreshEmailTargets();
        this.show_send_email = true;
        await this.service.render();
    }

    public async cancelEmail() {
        this.show_send_email = null;
        this.checked_email_list = [];
        this.emailSkippedSelectedCount = 0;
        this.emailTargetScope = "selected";
        await this.service.render();
    }

    public async uploadEmailAttachment() {
        if (!Array.isArray(this.emailForm.attachments)) this.emailForm.attachments = [];
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;

        await this.service.loading.show();
        try {
            for (let i = 0; i < files.length; i++) {
                const fd = new FormData();
                fd.append('upload', files[i]);
                const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
                this.emailForm.attachments.push({ name: files[i].name, url });
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async removeEmailAttachment(index: number) {
        if (!Array.isArray(this.emailForm.attachments)) return;
        this.emailForm.attachments.splice(index, 1);
        await this.service.render();
    }

    public async sendEmail() {
        if (!this.emailForm.title) {
            return await this.alert("이메일 제목을 입력해주세요.");
        }
        if (!this.emailForm.content) {
            return await this.alert("이메일 내용을 입력해주세요.");
        }
        this.refreshEmailTargets();
        if (this.emailTargetScope === "selected" && this.checked_email_list.length === 0) {
            return await this.alert("발송 가능한 선택 대상이 없습니다.");
        }

        this.emailSending = true;
        await this.service.loading.show();
        try {
            const { code, data } = await wiz.call("send_email", {
                fund_id: this.fund.id,
                emails: JSON.stringify(this.checked_email_list),
                target_scope: this.emailTargetScope,
                title: this.emailForm.title,
                content: this.emailForm.content,
                attachments: JSON.stringify(this.emailForm.attachments || []),
                skip_sent: this.emailSendMode === "unsent"
            });

            if (code != 200) {
                return await this.alert(data?.message || "메일 발송에 실패했습니다.");
            }

            let failedCount = (data.failed || []).length;
            let skipped = data.skipped || 0;
            let message = `${data.sent || 0}건 발송 완료`;
            if (skipped > 0) message += `, ${skipped}건 제외`;
            if (failedCount > 0) message += `, ${failedCount}건 실패`;
            await this.alert(message, failedCount > 0 ? "error" : "success");
            await this.cancelEmail();
            await this.load(this.search.page);
        } finally {
            this.emailSending = false;
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async onClickSendMessage() {
        this.checked_user_id = [];
        for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].selected) {
                this.checked_user_id.push(this.list[i].id);
            }
        }

        if (this.checked_user_id.length === 0) {
            return await this.alert("푸시메세지를 보낼 사람을 선택해주세요.");
        }

        this.show_send_message = true;
        await this.service.render();
    }
}

export default PortalLpsysadminWidgetFundInviteComponent;